import type React from 'react';
import { createRef, useEffect } from 'react';

export type MutationObserverOptions = MutationObserverInit & {
  triggerBeforeMutation?: boolean;
};

export interface MutationObserver {
  ref: React.RefObject<HTMLElement | null>;
  callback: MutationCallback;
  options?: MutationObserverOptions;
}

const useMutationObserver = (
  ref: MutationObserver['ref'] = createRef(),
  callback: MutationObserver['callback'],
  options: MutationObserver['options'] = {}
) => {
  useEffect(() => {
    if (ref.current) {
      const observer = new MutationObserver(callback);
      const { triggerBeforeMutation, ...observerOptions } = options;

      if (triggerBeforeMutation) {
        callback([], observer);
      }

      observer.observe(ref.current, observerOptions);

      return () => {
        observer.disconnect();
      };
    }

    return () => undefined;
  }, [callback, options, ref]);
};

export default useMutationObserver;
